export class ResetPassword {
  public email: string = '';
  public otp: string = '';
  /** Legacy registration flow only — link-key from email, not forgot-password OTP. */
  public passwordKey: string = '';
  public password: string = '';
  public confirmPassword: string = '';
}
